import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Shows a swipe hint on mobile when user first views a board.
 * Disappears after first scroll or after 3 seconds.
 */
export default function MobileKanbanHint({ listCount }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show on mobile and if there are multiple lists
    if (window.innerWidth >= 768 || listCount <= 1) return;

    const key = "kanban-hint-shown";
    if (sessionStorage.getItem(key)) return;

    setVisible(true);
    sessionStorage.setItem(key, "1");

    const timer = setTimeout(() => setVisible(false), 3000);
    const handleScroll = () => setVisible(false);

    const kanbanArea = document.querySelector('[data-testid="kanban-area"]');
    if (kanbanArea) kanbanArea.addEventListener("scroll", handleScroll, { once: true });

    return () => {
      clearTimeout(timer);
      if (kanbanArea) kanbanArea.removeEventListener("scroll", handleScroll);
    };
  }, [listCount]);

  if (!visible) return null;

  return (
    <div className="md:hidden fixed bottom-32 left-1/2 -translate-x-1/2 z-30 w-[min(82vw,22rem)] animate-fadeIn pointer-events-none">
      <div className="bg-black/80 text-white px-3 py-2 font-mono text-[10px] uppercase tracking-widest flex items-center justify-center gap-2 border border-white/20 backdrop-blur-sm text-center">
        <ChevronLeft size={12} strokeWidth={2.5} />
        <span>Geser untuk lihat daftar lain</span>
        <ChevronRight size={12} strokeWidth={2.5} />
      </div>
    </div>
  );
}
